import { render, staticRenderFns } from "./KnSubjectsAutocomplete.vue?vue&type=template&id=59df5eca"
import script from "./KnSubjectsAutocomplete.js?vue&type=script&lang=js&external"
export * from "./KnSubjectsAutocomplete.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports